import { css } from '@emotion/react'
import { Cell, Grid, Heading, HFlow, Icon, InfoLabel, Text, VFlow } from 'bold-ui'
import { InfoIcon } from 'components/InfoIcon'
import { Color } from 'csstype'
import { formatDate } from 'util/date/formatDate'
import { CidadaoListagemSaudeBucalQueryModel } from 'view/acompanhamento/acompanhamento-condicao-saude/model/lista-tematica/model-acompanhamentoCondicaoSaudeListaTematica'

import {
  PROCEDIMENTOS_EXODODONTIA_TOOLTIP_TEXT,
  PROCEDIMENTOS_PREVENTIVOS_TOOLTIP_TEXT,
  PROCEDIMENTOS_PRIMEIRA_CONSULTA_TOOLTIP_TEXT,
  REGISTROS_ESCOVACAO_TOOLTIP_TEXT,
  ULTIMO_TRATAMENTO_RESTAURADOR_TOOLTIP_TEXT,
} from './model-saudeBucal'

interface AcompanhamentoCondicaoSaudeBucalAccordionSectionProps {
  row: CidadaoListagemSaudeBucalQueryModel
  iconColor: Color
}

export function AcompanhamentoCondicaoSaudeBucalAccordionSection(
  props: Readonly<AcompanhamentoCondicaoSaudeBucalAccordionSectionProps>
) {
  const { iconColor, row } = props

  const {
    escovacaoSupervisionadaEmAc,
    exodontiasDentesRealizadas,
    procedimentoPreventivos,
    ultimoAtendimentoPrimeiraConsultaProgramada,
    ultimoAtendimentoTratamentoConcluido,
    ultimoTratamentoRestauradorAtraumatico,
  } = row.cidadao.cidadaoConsolidado.saudeBucal

  return (
    <VFlow>
      <Grid gap={1} gapVertical={0.5} alignItems='baseline' style={styles.grid}>
        <Cell size={12}>
          <HFlow hSpacing={0.25} alignItems='center'>
            <Icon icon='toothFilled' size={1} color={iconColor} />
            <Heading level={4}>Acompanhamento de saúde bucal</Heading>
          </HFlow>
        </Cell>
        <Cell size={3}>
          <VFlow vSpacing={0.125}>
            <Text>
              <Text fontWeight='bold' style={styles.textWithInfoIcon}>
                Primeira consulta
              </Text>
              <InfoIcon
                icon='infoCircleFilled'
                text={PROCEDIMENTOS_PRIMEIRA_CONSULTA_TOOLTIP_TEXT}
                style={styles.inlineInfoIcon}
                tooltipStyle={styles.tooltip}
              />
            </Text>
            <Text>{formatDate(ultimoAtendimentoPrimeiraConsultaProgramada?.iniciadoEm)}</Text>
          </VFlow>
        </Cell>
        <Cell size={3}>
          <InfoLabel title='Tratamento odontológico concluído'>
            {formatDate(ultimoAtendimentoTratamentoConcluido?.atendimentoProfissional?.iniciadoEm)}
          </InfoLabel>
        </Cell>
        <Cell size={3}>
          <VFlow vSpacing={0.125}>
            <Text>
              <Text fontWeight='bold' style={styles.textWithInfoIcon}>
                Último tratamento restaurador atraumático
              </Text>
              <InfoIcon
                icon='infoCircleFilled'
                text={ULTIMO_TRATAMENTO_RESTAURADOR_TOOLTIP_TEXT}
                tooltipStyle={styles.tooltip}
                style={styles.inlineInfoIcon}
              />
            </Text>
            <Text>{formatDate(ultimoTratamentoRestauradorAtraumatico?.atendimentoProfissional?.iniciadoEm)}</Text>
          </VFlow>
        </Cell>
        <Cell size={3}>
          <VFlow vSpacing={0.125}>
            <Text>
              <Text fontWeight='bold' style={styles.textWithInfoIcon}>
                Registro de escovação supervisionada em atividade coletiva
              </Text>
              <InfoIcon
                icon='infoCircleFilled'
                text={REGISTROS_ESCOVACAO_TOOLTIP_TEXT}
                style={styles.inlineInfoIcon}
                tooltipStyle={styles.tooltip}
              />
            </Text>
            <Text>{formatDate(escovacaoSupervisionadaEmAc)}</Text>
          </VFlow>
        </Cell>

        <Cell size={3}>
          <VFlow vSpacing={0.125}>
            <Text>
              <Text fontWeight='bold' style={styles.textWithInfoIcon}>
                Exodontias de dentes realizadas (permanentes)
              </Text>
              <InfoIcon
                icon='infoCircleFilled'
                text={PROCEDIMENTOS_EXODODONTIA_TOOLTIP_TEXT}
                style={styles.inlineInfoIcon}
                tooltipStyle={styles.tooltip}
              />
            </Text>
            <Text>{exodontiasDentesRealizadas ?? '-'}</Text>
          </VFlow>
        </Cell>
        <Cell size={3}>
          <VFlow vSpacing={0.125}>
            <Text>
              <Text fontWeight='bold' style={styles.textWithInfoIcon}>
                Procedimentos odontológicos preventivos
              </Text>
              <InfoIcon
                icon='infoCircleFilled'
                text={PROCEDIMENTOS_PREVENTIVOS_TOOLTIP_TEXT}
                style={styles.inlineInfoIcon}
                tooltipStyle={styles.tooltip}
              />
            </Text>
            <Text>{procedimentoPreventivos ?? '-'}</Text>
          </VFlow>
        </Cell>
      </Grid>
    </VFlow>
  )
}

const styles = {
  grid: css`
    padding: 0.5rem 0;
  `,
  tooltip: css`
    max-width: 31rem;
    white-space: pre-line;
  `,
  textWithInfoIcon: css`
    padding-right: 0.5rem;
  `,
  inlineInfoIcon: css`
    margin-left: -0.25rem;
    margin-bottom: -0.25rem;
  `,
}
